import { useState } from 'react';
import { makeStatBlock, STAT_IDS, STAT_LABELS, type StatBlock } from '@dcc/rules/domain/stats.ts';
import type { Character } from '@dcc/rules/domain/character.ts';
import { statAdvancementFor } from '@dcc/rules/app/crawlerAdvancementService.ts';

export function CrawlerLevelUpPanel({ character, busy, onConfirm }: {
  character: Character; busy: boolean;
  onConfirm: (allocation: StatBlock, saferoom: boolean) => Promise<boolean>;
}) {
  const [open, setOpen] = useState(false);
  const [saferoom, setSaferoom] = useState(false);
  const [allocation, setAllocation] = useState<StatBlock>(makeStatBlock(0));
  const points = statAdvancementFor(character);
  const total = STAT_IDS.reduce((sum, id) => sum + allocation[id], 0);
  const blocked = character.floor < 3 || points.needsReview || points.unspentPoints === 0;
  return <div>
    <p>{points.needsReview ? 'Ask your GM to review your unspent Stat Points before using Level Up.' : `${points.unspentPoints} unspent Stat Points.`} {character.floor < 3 ? 'Banked points unlock on Floor 3 and deeper.' : 'Allocate earned points in a saferoom. Remaining points can stay banked.'}</p>
    <button disabled={busy || blocked} onClick={() => setOpen(!open)}>Level Up · Allocate Stat Points</button>
    {open && !blocked && <div>
      <div className="dcc-creator-options">{STAT_IDS.map((id) => <label key={id} className="dcc-creator-field">
        {STAT_LABELS[id].full} {character.unenhancedStats[id]} → {character.unenhancedStats[id] + allocation[id]}
        <input type="number" min={0} max={points.unspentPoints} value={allocation[id]} disabled={busy} onChange={(e) => setAllocation({ ...allocation, [id]: Number(e.target.value) })} />
      </label>)}</div>
      <label><input type="checkbox" checked={saferoom} disabled={busy} onChange={(e) => setSaferoom(e.target.checked)} /> I am in a saferoom.</label>
      <p>{total} / {points.unspentPoints} points selected.</p>
      <button disabled={busy || !saferoom || !Number.isInteger(total) || total < 1 || total > points.unspentPoints} onClick={async () => {
        if (await onConfirm(allocation, saferoom)) { setOpen(false); setSaferoom(false); setAllocation(makeStatBlock(0)); }
      }}>Confirm allocation</button>
    </div>}
  </div>;
}
